import { DcDic } from '@/utils/dictionary'
import { formatDatetimeRange } from '@/utils/searcher'
import { cloneDeep } from 'lodash'

// /  网货 运费状态 字典
export class WaybillStatusDic extends DcDic {
    // static code 是必须的
    static code = 'NTP_WAYBILL_STATUS'

    /** 初始状态 */
    static INITIAL = 10
    /** "已调度" */
    static DISPATCHED = 20
    /** "已下发" */
    static SENT = 30
    /** "已同步" */
    static SYNCED = 40
    /** "已签署" */
    static DRIVER_SIGNED = 50
    /** "已装运" */
    static LOADED = 60
    /** "在途" */
    static IN_ROAD = 65
    /** "已抵达" */
    static ARRIVED = 70
    /** "已卸货" */
    static UNLOADED = 75
    /** "已签收" */
    static RECEIVER_SIGNED = 80
    /** "已审核" */
    static AUDITED = 85
    /** "异常运单" */
    static EXCEPTION = 90
    /** "运单中止" */
    static TERMINATED = 95
    /** "已作废" */
    static CANCELED = 99
    // TODO 2025-6-10发现：下述的10,20,40在字典系统里不存在，而30是已调度，50是已接单，60是已装车
    // TODO 而src\views\publishSource\wholeVehicle\utils\creatorDict.js里的WaybillStatusDict才是正确的NTP_WAYBILL_STATUS
}

// /  网货 运单支付状态 字典
export class WaybillPayStatusDic extends DcDic {
    // static code 是必须的
    static code = 'NTP_WAYBILL_PAY_STATUS'

    static PAYED = '20' // 已完成

    static isPayed(payStatus) {
        return payStatus === WaybillPayStatusDic.PAYED
    }
}

// /  网货运单列表时间查询类型 字典
export class WaybillCenterQueryTimeTypeDic extends DcDic {
    // static code 是必须的
    static code = 'NTP_WAYBILL_CENTER_TIME_TYPE'

    static DISPATCH = 10 // 调度时间
    static SEND = 20 // 发车时间
    static ARRIVE = 30 // 抵达时间
    static SIGN = 40 // 签收时间
    static SIGNTIME = 50 // 标记时间

    static patchSearchTime(params, timeRangeTypeKey, timeRangeKey) {
        // console.log(params[timeRangeTypeKey], params[timeRangeKey]);
        switch (+params[timeRangeTypeKey]) {
            case WaybillCenterQueryTimeTypeDic.DISPATCH:
                formatDatetimeRange(params, timeRangeKey, 'dispatchTimeStartTime', 'dispatchTimeEndTime')
                break
            case WaybillCenterQueryTimeTypeDic.SEND:
                formatDatetimeRange(params, timeRangeKey, 'departTimeStartTime', 'departTimeEndTime')
                break
            case WaybillCenterQueryTimeTypeDic.ARRIVE:
                formatDatetimeRange(params, timeRangeKey, 'arriveTimeStartTime', 'arriveTimeEndTime')
                break
            case WaybillCenterQueryTimeTypeDic.SIGN:
                formatDatetimeRange(params, timeRangeKey, 'signTimeStartTime', 'signTimeEndTime')
                break
            case WaybillCenterQueryTimeTypeDic.SIGNTIME:
                formatDatetimeRange(params, timeRangeKey, 'tabStartTime', 'tabEndTime')
                break
            default:
                formatDatetimeRange(params, timeRangeKey, 'dispatchTimeStartTime', 'dispatchTimeEndTime')
        }

        delete params[timeRangeKey]

        return params
    }
}

// /  网货 运费单支付申请状态 字典
export class WaybillPayApplyStatusDic extends DcDic {
    // static code 是必须的
    static code = 'NTP_APPLY_TYPE'

    static TO_APPLY = 0 // 待申请
    static APPLIED = 1 // 已申请
    static REJECTED = 2 // 已拒绝

    static isToApply(payApplyStatus) {
        return WaybillPayApplyStatusDic.TO_APPLY === +payApplyStatus
    }

    static isApplied(payApplyStatus) {
        return WaybillPayApplyStatusDic.APPLIED === +payApplyStatus
    }

    static isRejected(payApplyStatus) {
        return WaybillPayApplyStatusDic.REJECTED === +payApplyStatus
    }

    // 明细运费的申请状态中有 “未申请” 或 “已拒绝” 时，可以进行相应的明细运费支付申请
    static isAppliable(payApplyStatus) {
        return WaybillPayApplyStatusDic.APPLIED !== +payApplyStatus
    }
}

// /  运单表中 内部客户标识 字典
export class WaybillInnerCustomerTypeYnDict extends DcDic {
    // static code 是必须的
    static code = 'NTP_INNER_CUSTOMER_TYEP_YN'

    static YES = '1' // 是

    // 是内部客户
    static isByInnerCustomer(waybill) {
        return WaybillInnerCustomerTypeYnDict.YES === waybill.inFlag
    }
}

/**
 * 网货-大屏找车-车长；即标准车长。
 * 该字典的选项顺序有问题，如果要使用该字典作为下拉选项，建议如下使用：
 * const lengthDict = await DcDic.create(NtpMapCarlength)
 * const carLengthOptions = lengthDict.toOptions()
 */
export class NtpMapCarlength extends DcDic {
    static code = 'NTP_MAP_CARLENGTH'

    /*
     * 该字典的选项顺序有问题，要排序；
     * 因此，建议如下使用：
     * const lengthDict = await DcDic.create(NtpMapCarlength)
     * const carLengthOptions = lengthDict.toOptions()
     */
    toOptions() {
        let cloneOptions = cloneDeep(this.options)
        cloneOptions.sort((a, b) => +a.value - +b.value)
        cloneOptions = cloneOptions.map(item => {
            return {
                value: item.value,
                label: item.name,
            }
        })
        return cloneOptions
    }
}

/**
 * 网货-大屏找车-车型；即标准型
 */
export class NtpMapModel extends DcDic {
    static code = 'NTP_MAP_MODEL'
}

/**
 * 网货-运单作废-作废原因
 */
export class WaybillCancelReasonDic extends DcDic {
    static code = 'NTP_WAYBILL_CANCEL_REASON'
}

/**
 * 网货-网货渠道
 */
export class NTPChannelDic extends DcDic {
    static code = 'NTP_CHANNEL'

    /**
     * 天津安得
     */
    static TIAN_JIAN_ANNTO = '0'
    static LU_GE = '1' // 路歌
    static JU_MENG = '2' // 聚盟
    static G7 = '3' // G7
    static YI_YA_TONG = '4' // 怡亚通
    static HUA_NING = '5' // 华寗
    // static SHA_SHI_DI = '6' // 沙师弟
    // static WO_JIA_WU_LIU = '7' // 我家物流
    static QIAN_HAO_YUN_GROUP = [] // 签好运

    static isLuge(type) {
        return NTPChannelDic.LU_GE === String(type)
    }

    static isJuMeng(type) {
        return NTPChannelDic.JU_MENG === String(type)
    }
    static isG7(type) {
        return NTPChannelDic.G7 === String(type)
    }

    // 判断是否怡亚通
    static isYYTong(type) {
        return NTPChannelDic.YI_YA_TONG === String(type)
    }

    static isTJAnnto(type) {
        // return true
        return NTPChannelDic.TIAN_JIAN_ANNTO === String(type)
    }

    static isHuaning(type) {
        return WaybillChannelDict.HUA_NING === String(type)
    }
    // 判断签好运的编组
    static isQianHaoYunGroup(type, qianHaoYunCodes = []) {
        // // 确保 qianHaoYunCodes 是数组且不为空
        if (Array.isArray(qianHaoYunCodes) && qianHaoYunCodes.length > 0) {
            // 检查 type 是否在 qianHaoYunCodes 数组中
            return qianHaoYunCodes.includes(Number(type)) || qianHaoYunCodes.includes(String(type))
        } else {
            // 如果没有传入配置，则回退到默认的硬编码值
            return ['6', '7'].includes(String(type))
        }
    }
    // 添加一个设置签好运阿波罗配置的code值的方法
    static setQianHaoYunGroupCodes(codes) {
        NTPChannelDic.QIAN_HAO_YUN_GROUP = codes
    }
}

export class WaybillChannelDict extends NTPChannelDic {}

/**
 * 网货-异常预警-异常类型
 */
export class NtpAbnomalWarningExceptionTypeDict extends DcDic {
    static code = 'NTP_WAYBILL_WARN_TYPE'

    /**
     * "司机审核驳回!"
     */
    static DRIVER_AUDIT_REJECTION = 11

    /**
     * "车辆审核驳回"
     */
    static CAR_AUDIT_REJECTION = 12

    /**
     * "运单审核异常"
     */
    static BILL_AUDIT_ERROR = 13

    /**
     * "运单预审不通过"
     */
    static BILL_AUDIT_REFUSE = 14
}

/** 网货-网货平台接口日志-推送类型 */
export class PushTypeDict extends DcDic {
    static code = 'NTP_PUSH_TYPE'

    /** 运单创建 */
    static WAYBILL_CREATION = '0'
    /** 协议签署 */
    static AGREEMENT_SIGNING = '2'
    /** 会员认证 */
    static MEMBERSHIP_CERT = '3'
    /** 到达 */
    static ARRIVE = '4'
    /** 卸车照片/回单 */
    static UNLOAD_PIC_RETBILL = '5'
    /** 运单删除 */
    static WAYBILL_DELETE = '6'
    /** 运单修改 */
    static WAYBILL_MIDIFY = '7'
    /** 获取协议 */
    static GET_AGREEMENT = '8'
    /** 推送BMS发车时间 */
    static PUSH_BMS_DISPATCH_TIME = '9'
    /** 装车照片 */
    static LOAD_PIC = '10'
    /** 卸车照片 */
    static UNLOAD_PIC = '11'
    /** 车辆同步 */
    static CAR_SYNC = '12'
    /** 司机同步 */
    static DRIVER_SYNC = '13'
    /** 轨迹同步 */
    static TRACK_SYNC = '14'
    /** 运单签收 */
    static WAYBILL_SIGNING = '15'
    /** 熟车同步 */
    static FAMILIAR_CAR_SYNC = '16'
    /** 第三方订单风控同步 */
    static THIRD_ORDER_RISK_CTRL_SYNC = '17'
    /** 指派司机 */
    static DRIVER_ASIGN = '18'
    /** 风控申诉 */
    static RISK_CTRL_COMPLAINT = '19'
    /** 收款人同步 */
    static PAYEE_SYNC = '20'
    /** 运单状态同步 */
    static WAYBILL_STATUS_SYNC = '21'
    /** 车老板同步 */
    static CAR_OWNER_SYNC = '22'
    /** 单据照片补录 */
    static BILL_PIC_SUPPL = '23'
    /** 提货单照片 */
    static LADING_BILL = '24'
    /** 回单照片 */
    static RECEIPT_BILL = '25'
    /** 签署状态同步 */
    static SIGN_STATUS_SYNC = '26'
    /** 装车状态同步 */
    static LOAD_STATUS_SYNC = '27'
    /** 发车状态同步 */
    static DEPART_STATUS_SYNC = '28'
    /** 抵达状态同步 */
    static ARRIVE_STATUS_SYNC = '29'
    /** 签收状态同步 */
    static SIGN_FOR_RECEIVE_STATUS_SYNC = '31'
    /** 运力认证重推-签好运 */
    static TRANSPORT_REGISTER_RETWEET = '40'
    // 运力注册--签好运
    static CAPACITY_REGISTRATION = '39'
    // 车老板绑定结果查询--签好运
    static CAR_BOSS_RESULT_SEARCH = '41'
    // 车老板车辆绑定--签好运
    static CARBOSS_CAR_BINDING = '42'
    // 发车（运单起运）--签好运
    static CAR_START = '1'
    // 获取协议（接单合同获取）--签好运
    static GET_CONTRACT = '8'

    // 是否司机同步
    static isDriverSync(value) {
        return PushTypeDict.DRIVER_SYNC === String(value)
    }
    // 是否车辆同步
    static isCarSync(value) {
        return PushTypeDict.CAR_SYNC === String(value)
    }
    // 是否协议签署
    static isAgreementSigning(value) {
        return PushTypeDict.AGREEMENT_SIGNING === String(value)
    }
    // 是否创建订单
    static isWaybillCreation(value) {
        return PushTypeDict.WAYBILL_CREATION === String(value)
    }
    // 是否车老板同步
    static isCarOwnerSync(value) {
        return PushTypeDict.CAR_OWNER_SYNC === String(value)
    }
    // 是否第三方订单风控同步
    static isThirdOrderRiskCtrlSync(value) {
        return PushTypeDict.THIRD_ORDER_RISK_CTRL_SYNC === String(value)
    }
    // 是否轨迹同步
    static isTrackSync(value) {
        return PushTypeDict.TRACK_SYNC === String(value)
    }
}

/** 网货-接口日志-回调状态 */
export class PLoggerCallbackStatusDict extends DcDic {
    static code = 'NTP_CALLBACK_STATUS'

    static UNCALLBACK = '0' // 待回调
    static CALLBACKED = '1' // 已回调
    static NOT_NEED = '9' // 无需回调

    static isUnCallback(value) {
        return PLoggerCallbackStatusDict.UNCALLBACK === String(value)
    }

    static isCallbacked(value) {
        return PLoggerCallbackStatusDict.CALLBACKED === String(value)
    }

    static isNotNeed(value) {
        return PLoggerCallbackStatusDict.NOT_NEED === String(value)
    }
}

/**
 * 网货-司机或车辆-审批状态
 */
export class BaseAuditStatusDict extends DcDic {
    static code = 'NTP_BASE_AUDIT_STATUS'

    static DRAFT = '00' // 草稿
    static PROCESSING = '10' // 审批中
    static ADOPT = '20' // 审批通过
    static REJECT = '30' // 驳回
    static PRELIMINARY = '40' // 初审通过

    static isDraft(status) {
        return BaseAuditStatusDict.DRAFT === String(status)
    }
    static isProcessing(status) {
        return BaseAuditStatusDict.PROCESSING === String(status)
    }
    static isAdopt(status) {
        return BaseAuditStatusDict.ADOPT === String(status)
    }
    static isReject(status) {
        return BaseAuditStatusDict.REJECT === String(status)
    }

    static isPreliminary(status) {
        return BaseAuditStatusDict.PRELIMINARY === String(status)
    }

    /** 返回mipStatus相关的class样式名称 */
    static getTagClass(status) {
        if (status === null || status === undefined) {
            return null
        }
        return {
            draft: BaseAuditStatusDict.isDraft(status),
            processing: BaseAuditStatusDict.isProcessing(status),
            adopt: BaseAuditStatusDict.isAdopt(status), // 审批通过
            reject: BaseAuditStatusDict.isReject(status), // 驳回
            preliminary: BaseAuditStatusDict.isPreliminary(status), // 初审通过
        }
    }

    /**
     * 返回mipStatus相关的icon
     * import { CircleCheck, Warning, CircleCheckFilled, CircleCloseFilled } from '@element-plus/icons'
     * */
    static getMipStatusObj(status) {
        switch (String(status)) {
            case BaseAuditStatusDict.DRAFT: // 草稿
                return {
                    iconColor: '#E6A23C',
                    // iconComponent：这是<el-icon>组件的图标，在使用该函数的页面里要记得引入该组件才有效哦
                    iconComponent: 'Warning',
                    status: String(status),
                    title: '草稿',
                }
            case BaseAuditStatusDict.PROCESSING: // 审批中
                return {
                    iconColor: '#E6A23C',
                    iconComponent: 'Warning',
                    status: String(status),
                    title: '审批中',
                }
            case BaseAuditStatusDict.PRELIMINARY: // 初审通过
                return {
                    iconColor: '#67C23A',
                    iconComponent: 'CircleCheck',
                    status: String(status),
                    title: '初审通过',
                }
            case BaseAuditStatusDict.ADOPT: // 审批通过
                return {
                    iconColor: '#67C23A',
                    iconComponent: 'CircleCheckFilled',
                    status: String(status),
                    title: '审批通过',
                }
            case BaseAuditStatusDict.REJECT: // 驳回
                return {
                    iconColor: 'var(--el-color-error)',
                    iconComponent: 'CircleCloseFilled',
                    status: String(status),
                    title: '驳回',
                }
            default:
                return {}
        }
    }
}

/**
 * 'NTP_CERT_STATUS'
 */
export class WaybillCertStatusDict extends DcDic {
    static code = 'NTP_CERT_STATUS'

    /** 待提交 */
    static TO_SUBMIT = '0'
    /** 待认证 */
    static TO_CERT = '1'
    /** 认证通过 */
    static CERT_SUCCESS = '2'
    /** 认证失败 */
    static CERT_FAILED = '9'

    static isCertFailed(status) {
        return String(status) === WaybillCertStatusDict.CERT_FAILED
    }
}

/**
 * 网货-网货平台日志-请求结果
 */
export class ReqResultDict extends DcDic {
    static code = 'NTP_REQ_RESULT'

    /** 成功 */
    static SUCCESS = '0'

    /** 失败-注意：
     * @description 作为筛选条件：1-代表失败；
     * @description 但作为查询接口的返回数据，那只有0-代表成功，其他值都是失败！会出现各种各样的code。
     * */
    static FAIL = '1'

    /** true-成功 */
    static isSuccess(status) {
        return String(status) === ReqResultDict.SUCCESS
    }
}

/**
 * 网货-平台主体
 */
export class PlatformAccountingEntityDict extends DcDic {
    static code = 'NTP_PT_ACCOUNTING_ENTITY'

    /** 全部 */
    static ALL = '0'
    /** 天津安得网络科技有限公司 */
    static TIAN_JIAN_ANNTO = '100013'
    /** 海南美途智联网络科技有限公司 */
    static HAI_NAN_MEI_TU = '157001'

    /** true-全部 */
    static isAll(type) {
        return String(type) === PlatformAccountingEntityDict.ALL
    }
    /** true-天津安得网络科技有限公司 */
    static isTianJianAnnto(type) {
        return String(type) === PlatformAccountingEntityDict.TIAN_JIAN_ANNTO
    }

    /** true-海南美途智联网络科技有限公司 */
    static isHaiNanMeiTu(type) {
        return String(type) === PlatformAccountingEntityDict.HAI_NAN_MEI_TU
    }
}
/**
 * 网货-平台主体-简称
 */
export class PlatformAccountingEntityShortDict extends DcDic {
    static code = 'NTP_PT_ACCOUNTING_ENTITY_SHORT'

    /** 全部 */
    static ALL = PlatformAccountingEntityDict.ALL
    /** 天津安得 */
    static TIAN_JIAN_ANNTO = PlatformAccountingEntityDict.TIAN_JIAN_ANNTO
    /** 海南美途 */
    static HAI_NAN_MEI_TU = PlatformAccountingEntityDict.HAI_NAN_MEI_TU
}
